import {
  IconCrystalBall,
  IconCustomAlignJustifiedCheck,
  IconCustomBorderCornersCheck,
  IconCustomLayoutGridCheck,
  IconDatabaseSearch,
  IconLayoutList,
  IconMathFunction,
  IconSection,
  IconTable,
} from '@rossum/ui/icons/tabler';
import { SvgIcon, SxProps, Theme } from '@rossum/ui/material';

type ValueIconProps = { value: string };

export const ValueIcon = ({ value }: ValueIconProps) => {
  const sx: SxProps<Theme> = {
    verticalAlign: 'middle',
    color: theme => theme.palette.text.secondary,
  };

  switch (value) {
    case 'Single value':
      return (
        <SvgIcon fontSize="large" sx={sx}>
          <IconSection />
        </SvgIcon>
      );

    case 'Line items':
      return (
        <SvgIcon fontSize="large" sx={sx}>
          <IconTable />
        </SvgIcon>
      );

    case 'Multivalue':
      return (
        <SvgIcon fontSize="large" sx={sx}>
          <IconLayoutList />
        </SvgIcon>
      );

    case 'Line item':
      return (
        <SvgIcon fontSize="large" sx={sx}>
          <IconTable />
        </SvgIcon>
      );

    case 'Captured':
      return (
        <SvgIcon fontSize="large" sx={sx}>
          <IconCustomBorderCornersCheck />
        </SvgIcon>
      );

    case 'Formula':
      return (
        <SvgIcon fontSize="large" sx={sx}>
          <IconMathFunction />
        </SvgIcon>
      );

    case 'Lookup':
      return (
        <SvgIcon fontSize="large" sx={sx}>
          <IconDatabaseSearch />
        </SvgIcon>
      );

    case 'Reasoning':
      return (
        <SvgIcon fontSize="large" sx={sx}>
          <IconCrystalBall />
        </SvgIcon>
      );

    case 'Data':
      return (
        <SvgIcon fontSize="large" sx={sx}>
          <IconCustomLayoutGridCheck />
        </SvgIcon>
      );

    case 'Manual':
      return (
        <SvgIcon fontSize="large" sx={sx}>
          <IconCustomAlignJustifiedCheck />
        </SvgIcon>
      );

    default:
      return null;
  }
};
